// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3cTaL","col":"styles_col__1bRgP"};